import { render } from "./privacy_policy_ios.vue?vue&type=template&id=31be8616&scoped=true"
import script from "./privacy_policy_ios.vue?vue&type=script&lang=js"
export * from "./privacy_policy_ios.vue?vue&type=script&lang=js"

import "./privacy_policy_ios.vue?vue&type=style&index=0&id=31be8616&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31be8616"]])

export default __exports__